<template>
  <div
    class="scroll-page-buttons"
    :style="{
      '--button-page-size': pageSize,
      '--button-item-size': `${itemSize}px`,
      '--button-space-size': `${spaceSize}px`
    }"
  >
    <SjIcon
      class="scroll-prev-page"
      iconClass="compagi_pre"
      theme="3"
      @click.native="onPrevPageClick"
    ></SjIcon>
    <div class="scroll-button-wrapper">
      <div
        class="scroll-button"
        v-for="(button, i) in data"
        :key="i"
        @click="onButtonClick(button)"
      >
        <div class="content">{{ button.label }}</div>
      </div>
    </div>
    <SjIcon
      class="scroll-next-page"
      iconClass="compagi_next"
      theme="3"
      @click.native="onNextPageClick"
    ></SjIcon>
  </div>
</template>

<script>
import scrollMixin from "./scrollMixin";
export default {
  name: "SjScrollPageButtons",
  mixins: [scrollMixin],
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    pageSize: {
      type: Number,
      default: 5
    },
    itemSize: {
      type: Number,
      default: 100
    },
    spaceSize: {
      type: Number,
      default: 15
    }
  },
  computed: {
    pageDiff() {
      return this.pageSize * this.itemSize + this.pageSize * this.spaceSize;
    }
  },
  methods: {
    onButtonClick(item) {
      this.$emit("select", item);
    },
    onPrevPageClick() {
      const container = this.$el.querySelector(".scroll-button-wrapper");
      this.animateScroll(container, -this.pageDiff);
    },
    onNextPageClick() {
      const container = this.$el.querySelector(".scroll-button-wrapper");
      this.animateScroll(container, this.pageDiff);
    }
  }
};
</script>

<style scoped lang="less">
.scroll-page-buttons {
  margin: 0 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .scroll-prev-page {
    flex-shrink: 0;
  }
  .scroll-button-wrapper {
    margin: 0 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-width: calc(
      var(--button-page-size) * var(--button-item-size) +
        calc(var(--button-page-size) - 1) * var(--button-space-size)
    );
    overflow: hidden;

    .scroll-button {
      flex-shrink: 0;
      width: var(--button-item-size);
      max-width: var(--button-item-size);
      height: 20px;
      padding: 0 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 2px;
      box-sizing: border-box;
      .text("caption", "alert-success");
      &:hover {
        .text("caption", "antibg");
        background-color: @color-alert-success;
      }
      .content {
        flex-grow: 1;
        flex-shrink: 0;
        flex-basis: 0;
        min-width: 0;
        text-align: center;
        .text-ellipsis();
      }

      & + .scroll-button {
        margin-left: var(--button-space-size);
      }
    }
  }
  .scroll-next-page {
    flex-shrink: 0;
  }
}
</style>
